import * as React from "react";
const SvgFlash = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.7501 8.24918V1.10742L1.56445 15.7489H10.2502V22.8897L20.4348 8.24918H11.7501Z" }));
export default SvgFlash;
